import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  IconButton,
} from "@mui/material";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoEyeSharp } from "react-icons/io5";
import xlsIcon from "../../../assets/images/xls.png";
import * as XLSX from "xlsx";
import SearchBar from "../Logs/SearchBar";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableContainer,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch, useSelector } from "react-redux";
import { AdminReportsApi } from "../../../features/Admin/Reports/AdminReports";
import CustomDatePicker from "../../../components/common/CustomDatePicker";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";
import { getHiredCandidatesReportClientApi } from "../../../features/Client/ClientReports/HiredCandidateSlice";
import NormalDatePicker from "../../../components/common/NormalDatePicker";
import CustomSearchField from "../../../components/common/CustomSearchField";
import { debounce } from "lodash";
import ExportToExcelButton from "../../../components/common/ExportToExcelButton";
import RefreshButton from "../../../components/common/RefreshButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CandidateViewDetail from "../../Client/ClientSearch/CandidateViewDetail";
import CustomPagination from "../../../components/common/CustomPagination";
import {
  convertTimestampToDate,
  formatAmount,
  formatUSAmount,
} from "../../../utils/helpers";
import {
  applyCellStyles,
  generateColumnWidths,
} from "../../../components/common/ExcelFormatter";
import { exportToExcelAll } from "../../../components/common/ExportToExcel";
import {
  renderLastThreeIndustry,
  renderLastThreeIndustryAsString,
  renderLastThreeJobs,
  renderLastThreeJobsAsString,
} from "../../../components/common/RenderLastThreeJobs";
const HiredCandidates = ({ usertype, clientId = null, headers }) => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
    const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) : new Date();
  const [fromDate, setFromDate] = useState(
    dayjs(today).subtract(1, "year").toDate()
  );
  const [toDate, setToDate] = useState(dayjs(today).toDate());
  const [lodaing, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [Count, setCount] = useState(1);
  const [excelLogo, setExcelLogo] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [isView, setIsView] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const getHiredCandidatesReport = async (
    query = searchQuery,
    pageNum = 1,
    startDate = fromDate,
    endDate = toDate,
    pageSize = rowsPerPage
  ) => {
    setLoading(true);
    let data = {
      status: "hired",
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      pagesize: pageSize,
      pagenumber: pageNum === 0 ? 1 : pageNum,
      searchitem: query,
      export: false,
    };
    try {
      const { payload } = await dispatch(AdminReportsApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const HandleEdit = (select) => {
    setSelectedCandidate(select);
    setIsView(true);
  };

  const getHiredCandidatesReportReset = async (from, to, s) => {
    setLoading(true);
    let data = {
      status: "hired",
      fromDate: formatDate(from),
      toDate: formatDate(to),
      pagenumber: 1,
      pagesize: s,
      searchitem: "",
      export: false,
    };
    try {
      const { payload } = await dispatch(AdminReportsApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getHiredCandidatesReportExport = async () => {
    setExcelLogo(true);
    let requestData = {
      status: "hired",
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      export: true,
    };

    try {
      const { payload } = await dispatch(AdminReportsApi(requestData));

      if (payload.status === 200) {
        let data = payload.data || [];

        if (data.length === 0) {
          notifyError("No data available for export");
          setExcelLogo(false); // Stop showing the Excel logo
          return; // Early return if no data is available
        }

        exportToExcel(data); // Proceed with exporting if data is available
      }
    } catch (err) {
      console.error(err);
      notifyError("Error: Unable to export data");
    } finally {
      setExcelLogo(false);
    }
  };

  const helperFunction = () => {
    setPage(1);
    getHiredCandidatesReport();
  };

  useEffect(() => {
    getHiredCandidatesReport(searchQuery, page);
  }, []);

  function formatDate(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  //   if (!timestamp || isNaN(timestamp)) {
  //     throw new Error("Invalid timestamp");
  //   }
  //   const date = new Date(timestamp);
  //   const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
  //   const day = String(date.getUTCDate()).padStart(2, '0');
  //   const year = date.getUTCFullYear();
  //   return `${month}/${day}/${year}`;
  // };

  const exportToExcel = (ExportedData) => {
    // Prepare headers based on usertype
    const headers = [];

    // Prepare data for export
    const formattedData = ExportedData.map((row, index) => {
      const hiredStatus = row.candidate_statusinfo.find(
        (statusInfo) => statusInfo.status.toLowerCase() === "hired"
      );
      const hiringDate = convertTimestampToDate(row.candidate_hiredate.$date);

      let clientName = "";
      if (usertype === "admin") {
        clientName = hiredStatus?.client_name || "N/A";
      }
      const lastPaymentStatus = row?.client_paymentinfo?.reduce(
        (latest, current) => {
          return latest.cdate.$date > current.cdate.$date ? latest : current;
        }
      );

      const PaymentDate = convertTimestampToDate(
        lastPaymentStatus?.cdate?.$date
      );

      let reqPayMentDate = convertTimestampToDate(
        row.recruiter_paymentDate?.$date
      );

      const jobTitle = renderLastThreeJobsAsString(row.candidate_company);
      const sector = renderLastThreeIndustryAsString(row.candidate_company);

      // Prepare row data based on usertype
      const rowData = {
        No: index + 1,
        "Name of Candidate": `${row.candidate_firstname} ${row.candidate_lastname}`,
        "Job Title": jobTitle,
        "Job Industry/Sector": sector,
        Email: row.candidate_email,
        "Contact No.": row.candidate_contactno,
      
        "No. of Year Experiance": row.candidate_experiance,
        "Geographic Preference":
          row.candidate_anylocation === "any"
            ? "Any Location"
            : row.candidate_specifiedlocation
                ?.map((label) => label)
                ?.join(", "),
        "Language Proficiency": row.candidate_language_reference
          ?.map((lang) => lang.label)
          ?.join(", "),
        "Compensation Range ( Base Salary + Bonus In cash / year)": `$${formatAmount(
          row.candidate_compensation_from
        )} to $${formatAmount(row.candidate_compensation_to)}`,
      };
      if (usertype === "admin") {
        rowData["Hired By"] = clientName;
        rowData["Uploaded By"] = row.recruiter_name || "N/A";
        rowData["Search By"] = row.searchperson;
        rowData["Date Of Hire"] = hiringDate;
        rowData["Compensation Offered"] = `$${row.candidate_totalamount}`;
        rowData["Admin Commission"] = row.admin_commission
          ? formatUSAmount(row.admin_commission)
          : "-";
        rowData["Admin Payment Mode"] = row.paymentmode
          ? row.paymentmode.toLowerCase() === "online"
            ? "Stripe"
            : row.paymentmode.toLowerCase() === "offline"
            ? "Offline"
            : "-"
          : "-";
        rowData["Admin Payment Status"] = lastPaymentStatus?.status
          ? lastPaymentStatus?.status
          : "-";
        rowData["Admin Payment Date"] = PaymentDate ? PaymentDate : "-";
        rowData["Recruiter Commission"] = row.recruiter_percentage
          ? row.recruiter_percentage
          : "-";
        rowData["Recruiter Payment Mode"] = row.payment_type
          ? row.payment_type
          : "-";
        rowData["Recruiter Payment Status"] = row.recruiter_paymentstatus
          ? row.recruiter_paymentstatus
          : "-";
        rowData["Recruiter Payment Date"] = reqPayMentDate
          ? reqPayMentDate
          : "-";
      }

      return rowData;
    });

    exportToExcelAll(
      formattedData,
      "Hired Candidates Report",
      "Hired Candidates Report.xlsx"
    );
  };

  const handlePageChange = (value) => {
    setPage(value);
    getHiredCandidatesReport(searchQuery, value);
  };
  const debouncedSearch = useCallback(
    debounce((query, page, updatedFrom, updatedTo) => {
      getHiredCandidatesReport(query, page, updatedFrom, updatedTo);
    }, 1300),
    []
  );

  useEffect(() => {
    setLoading(false);
    debouncedSearch(searchQuery, page, fromDate, toDate);
  }, [searchQuery]);


  const handleFromDateChange = (date) => {
    setFromDate(date); // Update the from date
    // If the new from date is greater than the current to date, reset the to date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const reset = async () => {
    setSearchQuery("");
    let from = dayjs().subtract(1, "year").toDate();
    let to = dayjs().toDate();
    setFromDate(from);
    setToDate(to);
    setRowsPerPage(10);
    setTimeout(() => getHiredCandidatesReportReset(from, to, 10), 0);
    setPage(1);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
    getHiredCandidatesReport(searchQuery, 1, fromDate, toDate, newRowsPerPage);
  };

  if (lodaing) return <Loader />;

  return (
    <>
      {isView === false ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "40px",
                textAlign: "left",
              }}
            >
              Hired Candidates
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // Row on medium screens, column on small screens
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#fff",
              p: 3,
              borderRadius: "10px",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              {/* Left Section: Date Pickers and Apply Button */}
              <Grid item xs={12} md={8}>
                <Grid container spacing={2} alignItems="center">
                  {/* From Date Picker */}
                  <Grid item xs={12} sm={6} md={3}>
                    <NormalDatePicker
                      label="From date"
                      name="from_date"
                      selected={fromDate}
                      onChange={handleFromDateChange}
                      maxDate={today} // Disable dates greater than today
                    />
                  </Grid>

                  {/* To Date Picker */}
                  <Grid item xs={12} sm={6} md={3}>
                    <NormalDatePicker
                      label="To date"
                      name="to_date"
                      selected={toDate}
                      onChange={handleToDateChange}
                      maxDate={today} // Disable dates greater than today
                      minDate={fromDate} // Only allow dates greater than or equal to the from date
                    />
                  </Grid>

                  {/* Apply and Refresh Buttons */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Grid container spacing={2} alignItems="center">
                      {/* Apply Button */}
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{ fontFamily: "Urbane-Light" }}
                          onClick={() => helperFunction()}
                        >
                          Apply
                        </Button>
                      </Grid>

                      {/* Refresh Button */}
                      <Grid item>
                        <RefreshButton onClick={reset} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Section: Search Field and Export Button */}
              <Grid item xs={12} md={4}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  {/* Search Field */}
                  <Grid item xs={8}>
                    <CustomSearchField
                      searchQuery={searchQuery}
                      setSearchQuery={setSearchQuery}
                    />
                  </Grid>

                  {/* Export Button */}
                  <Grid item xs={4}>
                    <ExportToExcelButton
                      onClick={getHiredCandidatesReportExport}
                      disabled={excelLogo}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <StyledTableContainer
              component={Paper}
              sx={{ width: "100%", margin: "auto", mt: 3 }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {headers?.map((header, index) => (
                      <StyledTableCell
                        key={index}
                        colSpan={
                          header === "Function, Department or Expertise" ? 3 : 1
                        }
                      >
                        {header}
                      </StyledTableCell>
                    ))}
                    <StyledTableCell>Job Title</StyledTableCell>
                    <StyledTableCell>Job Industry/Sector</StyledTableCell>
                    <StyledTableCell>No. of Year Experiance</StyledTableCell>
                    <StyledTableCell>Geographic Preference</StyledTableCell>
                    <StyledTableCell>Language Proficiency</StyledTableCell>
                    <StyledTableCell>
                      Compensation Range <br /> ( Base Salary + Bonus In cash /
                      year)
                    </StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data && data.length > 0 ? (
                    data.map((row, index) => {
                      const hiredStatus = row.candidate_statusinfo.find(
                        (statusInfo) =>
                          statusInfo.status.toLowerCase() === "hired"
                      );
                      const lastPaymentStatus = row?.client_paymentinfo?.reduce(
                        (latest, current) => {
                          return latest.cdate.$date > current.cdate.$date
                            ? latest
                            : current;
                        }
                      );

                      const hiringDate = convertTimestampToDate(
                        row.candidate_hiredate.$date
                      );

                      let clientName;
                      if (usertype === "admin") {
                        clientName = hiredStatus?.client_name;
                      }
                      const PaymentDate = convertTimestampToDate(
                        lastPaymentStatus?.cdate?.$date
                      );

                      let reqPayMentDate = convertTimestampToDate(
                        row.recruiter_paymentDate?.$date
                      );

                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#f5f5f5",
                            },
                            fontSize: "12px",
                          }}
                        >
                          <StyledTableRow>{row.serialnumber}.</StyledTableRow>
                          <StyledTableRow>{`${row.candidate_firstname} ${row.candidate_lastname}`}</StyledTableRow>

                          <StyledTableRow>{row.candidate_email}</StyledTableRow>
                          <StyledTableRow style={{ whiteSpace: "nowrap" }}>
                            {row.candidate_contactno}
                          </StyledTableRow>
                          <StyledTableRow>{clientName}</StyledTableRow>

                          <StyledTableRow
                            sx={{
                              textTransform: "capitalize",
                              minWidth: "160px",
                            }}
                          >
                            {`${row.recruiter_name} (${row.user_type}) `}
                          </StyledTableRow>
                          <StyledTableRow>{row.searchperson}</StyledTableRow>
                          <StyledTableRow>{hiringDate}</StyledTableRow>
                          <StyledTableRow align="right">
                            {formatUSAmount(row.candidate_totalamount)}
                          </StyledTableRow>
                          <StyledTableRow align="right">
                            {row.admin_commission
                              ? formatUSAmount(row.admin_commission)
                              : "-"}
                          </StyledTableRow>
                          <StyledTableRow>
                            {row.paymentmode
                              ? row.paymentmode.toLowerCase() === "online"
                                ? "Stripe"
                                : row.paymentmode.toLowerCase() === "offline"
                                ? "Offline"
                                : "-"
                              : "-"}
                          </StyledTableRow>

                          <StyledTableRow sx={{ textTransform: "capitalize" }}>
                            {lastPaymentStatus?.status
                              ? lastPaymentStatus?.status
                              : "-"}
                          </StyledTableRow>
                          <StyledTableRow>
                            {PaymentDate ? PaymentDate : "-"}
                          </StyledTableRow>
                          <StyledTableRow align="right">
                            {row.recruiter_percentage
                              ? formatUSAmount(row.recruiter_percentage)
                              : "-"}
                          </StyledTableRow>

                          <StyledTableRow sx={{ textTransform: "capitalize" }}>
                            {row.payment_type ? row.payment_type : "-"}
                          </StyledTableRow>

                          <StyledTableRow sx={{ textTransform: "capitalize" }}>
                            {row.recruiter_paymentstatus
                              ? row.recruiter_paymentstatus
                              : "-"}
                          </StyledTableRow>

                          <StyledTableRow sx={{ textTransform: "capitalize" }}>
                            {reqPayMentDate ? reqPayMentDate : "-"}
                          </StyledTableRow>
                            <StyledTableRow>
                                                     {renderLastThreeJobs(row.candidate_company)}
                                                   </StyledTableRow>
                                                   <StyledTableRow>
                                                     {renderLastThreeIndustry(row.candidate_company)}
                                                   </StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_experiance}
                          </StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_anylocation === "any"
                              ? "Any Location"
                              : Array.isArray(
                                  row.candidate_specifiedlocation
                                ) &&
                                row.candidate_specifiedlocation?.map(
                                  (label, idx) => (
                                    <React.Fragment key={idx}>
                                      {label}
                                      {idx <
                                        row.candidate_specifiedlocation
                                          ?.length -
                                          1 && <br />}
                                    </React.Fragment>
                                  )
                                )}
                          </StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_language_reference?.map(
                              (lang, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {lang.label}
                                    {row.candidate_language_reference?.length -
                                      1 >
                                      index && <span>, </span>}
                                  </React.Fragment>
                                );
                              }
                            )}
                          </StyledTableRow>
                          <StyledTableRow align="right">{`${formatUSAmount(
                            row.candidate_compensation_from
                          )} - ${formatUSAmount(
                            row.candidate_compensation_to
                          )}`}</StyledTableRow>
                          <StyledTableRow>
                            <IconButton
                              edge="end"
                              color="primary"
                              onClick={() => HandleEdit(row)}
                              aria-label="view"
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </StyledTableRow>
                        </TableRow>
                      );
                    })
                  ) : (
                    <>
                      <NoDataFoundRow
                        colSpan={13}
                        message="Candidates are not available!"
                      />
                    </>
                  )}
                </TableBody>
              </Table>
            </StyledTableContainer>
            {data?.length > 0 && (
              <CustomPagination
                totalRecords={Count}
                rowsPerPageOptions={[10, 25, 50, 100]}
                initialRowsPerPage={rowsPerPage}
                setRowsPerPage1={setRowsPerPage}
                initialPage={page - 1}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}
          </Box>
        </>
      ) : (
        <CandidateViewDetail
          selectedCandidate={selectedCandidate}
          setisView={setIsView}
          getallcandidatesData={getHiredCandidatesReport}
          isView={isView}
          isReport={true}
          fromAdminReport={true}
          reportName={"Hired"}
          DateFindBy={"hired"}
        />
      )}
    </>
  );
};

export default HiredCandidates;
